import BiometricProvider, { useBiometricContext } from './BiometricProvider';

export default BiometricProvider;
export { useBiometricContext };
